import { render, staticRenderFns } from "./businessTable.vue?vue&type=template&id=a366416e&scoped=true"
import script from "./businessTable.vue?vue&type=script&lang=js"
export * from "./businessTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a366416e",
  null
  
)

export default component.exports